import React from 'react';
import { Box } from '@chakra-ui/react';
import { ICOCConfig } from '@publishing-engine/domain/models';
import CocConfiguration from '../CocConfiguration';
import { COCRecommendationLockReason } from '../CocConfiguration/types';
import { Membership } from '../Membership';
import SectionNavLayout from './SectionNavLayout';

const EDITORIAL_WORKFLOW_SECTIONS = [
  { id: 'role-assignments', label: 'Role Assignments' },
  { id: 'member-assignments', label: 'Member Assignments' }
];

interface EditorialWorkflowTabProps {
  journalId: string;
  workspaceId: string;
  journalName: string;
  cocConfig?: ICOCConfig[];
  isCOCRecommendationRequired?: boolean;
  recommendationLockReason?: COCRecommendationLockReason;
  isJournalLocked?: boolean;
}

const EditorialWorkflowTab: React.FC<EditorialWorkflowTabProps> = ({
  journalId,
  workspaceId,
  journalName,
  cocConfig,
  isCOCRecommendationRequired,
  recommendationLockReason,
  isJournalLocked
}) => {
  return (
    <SectionNavLayout
      title="Assignments"
      sections={EDITORIAL_WORKFLOW_SECTIONS}
    >
      <Box id="role-assignments">
        <CocConfiguration
          initialConfig={cocConfig}
          journalId={journalId}
          workspaceId={workspaceId}
          isCOCRecommendationRequired={isCOCRecommendationRequired}
          recommendationLockReason={recommendationLockReason}
          isJournalLocked={isJournalLocked}
        />
      </Box>
      <Box id="member-assignments">
        <Membership
          workspaceId={workspaceId}
          journalId={journalId}
          journalName={journalName}
        />
      </Box>
    </SectionNavLayout>
  );
};

export default React.memo(EditorialWorkflowTab);
